import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'listByPage': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const providersOrdersManagement = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PROVIDERS_ORDERS_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PROVIDERS_ORDERS_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'listByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_PROVIDERS_ORDERS_MANAGEMENT_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'listByPage': [],
    }),
    [ActionTypes.CHANGE_PROVIDERS_ORDERS_MANAGEMENT_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'listByPage': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_PROVIDERS_ORDERS_MANAGEMENT_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'listByPage': [...getPage(state.list, 0, action.payload)],
    }),
  })(state, action);
};
